import { tintHexColor, darkenToContrast } from './colorAttributes'

export const DEFAULT_ACCENT_COLOR = '#045db5'
export const MAX_INFO_PRICES_ROWS = 6

// Inline styles of the "Informative prices" block, shared by renderHTML (saved HTML) and the
// editor node view so both look the same. No fixed widths: whole rows wrap to the next line, and
// a word only breaks (break-word, not anywhere) when it alone doesn't fit the card, from 320px up.
// Neutral rows are #374151 on #ebebeb (~8.7:1).
export const INFO_PRICES_STYLES = {
  card: 'margin:16px 0;padding:24px 16px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;'
    + 'text-align:center;overflow-wrap:break-word;',
  title: 'margin:0 0 16px;font-size:18px;font-weight:bold;',
  rows: 'display:flex;flex-wrap:wrap;justify-content:center;gap:8px;',
  row: 'display:inline-flex;flex-wrap:wrap;justify-content:center;align-items:baseline;column-gap:8px;'
    + 'max-width:100%;min-width:0;overflow-wrap:break-word;padding:8px 16px;border-radius:999px;',
  neutralRow: 'background:#ebebeb;color:#374151;',
}

// First row: light tint of the accent with the accent darkened to >= 4.5:1 on it.
// `color` must already be a validated #rrggbb.
export function infoPricesAccentStyle(color) {
  const background = tintHexColor(color)
  return `background:${background};color:${darkenToContrast(color, background)};`
}
